export default "Work on a new car has started!";